import * as yup from 'yup';

const REQUIRED_MESSAGE = 'Por favor, preencha este campo';

export const configurationStepSchema = yup.object({
  averageContentTimeInMinutes: yup
    .number()
    .min(1, 'Selecione a duração da média da aula')
    .required(REQUIRED_MESSAGE),
  totalDurationInDays: yup
    .number()
    .min(1, 'Selecione a duração total do programa')
    .required(REQUIRED_MESSAGE),
  durationMeasure: yup.number().nullable(),
  numberOfClasses: yup.number().nullable(),
  objectiveId: yup.number().required('Selecione pelo menos um objetivo.'),
  categoryId: yup.number().required(REQUIRED_MESSAGE),
  levelId: yup.number().required(REQUIRED_MESSAGE),
  modalityIds: yup
    .array()
    .of(yup.number().required(REQUIRED_MESSAGE))
    .min(1, 'Selecione pelo menos uma modalidade.')
    .required(REQUIRED_MESSAGE),
  tags: yup
    .array()
    .of(yup.string().required(REQUIRED_MESSAGE))
    .min(1, 'Selecione pelo menos uma tag.')
    .required(REQUIRED_MESSAGE),
  accessory: yup.boolean().required(REQUIRED_MESSAGE),
  gender: yup
    .array()
    .of(yup.string().required(REQUIRED_MESSAGE))
    .min(1, 'Selecione pelo menos um gênero.')
    .required(REQUIRED_MESSAGE),
  forMothers: yup.string().required(REQUIRED_MESSAGE),
  durationValue: yup.string().required(REQUIRED_MESSAGE),
  isRecommendQuiz: yup.boolean().required(REQUIRED_MESSAGE),
  trainingDaysAvailable: yup
    .number()
    .min(1, 'Selecione a disponibilidade mínima de dias para treinar')
    .required(REQUIRED_MESSAGE),
  showInSearch: yup.boolean().required(REQUIRED_MESSAGE),
});

export type ConfigurationStepForm = yup.InferType<
  typeof configurationStepSchema
>;
